import axiosInstance from './AxiosInstance';
import qs from 'qs';

export default class EventService {
    constructor() {
        this.endpoint = "/api/events"
    }

    async getAll(params) {
        try {
            const response = await axiosInstance.get(this.endpoint, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async getEventByRegisterAll(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/register`, {
                params,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async GetEventByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async GetEventGroupByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/group/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getAllGroups() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/groups`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async getDemarcationLevels() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/delimitation/levels`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getAllEvents(params) {
        try {
            const response = await axiosInstance.get(this.endpoint,
            {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async getAllEventStaff(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/staff`,
            {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async getSavedEventParameters(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/event/parameters`,
            {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async GetEventDelimitations(params)
    {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/delimitations`,
            {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    
    async getEventTypes() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/types`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async GetEventCategories() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/categories`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    
    async GetCategoryEventTypesByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/types/category/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async DeActivateByElection(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/deactivate/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async IsVoterNotAlreadyAStaffMemberCheckAsync(idNumber) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/idnNumber/${idNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async GetCategoryParametersByIdAsync(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/parameters/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async GetCategoryParametersByAsync(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/parameters`,
                {
                    params,
                    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
    async getByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async create(data) {
        try {
            const response = await axiosInstance.post(this.endpoint, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async saveSignature(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/signatures`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async createStaff(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/staff`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async editEvent(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/edit`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async editGroup(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/group/edit`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async createGroup(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/group/create`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    async deleteGroup(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/group/delete`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    async activate(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/deactivate`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async AddEventDelimitationParameter(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/event/parameters`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }
    async deleteEventStaff(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/staff/remove`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    async getEventDocuments() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/documents/types`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async addDelimitationDocuments(data) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}/${data?.eventID}/documents`, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    // async getDelimitationDocuments(data) {
    //     try {
    //         const response = await axiosInstance.put(`${this.endpoint}/api/events/${data?.eventID}/documents`);
    //         return response.data;
    //     } catch (error) {
    //         console.error('Error posting data:', error);
    //         throw error;
    //     }
    // }

    async getDelimitationDocuments(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}/documents`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async deleteEventDocument(id) {
    try {
        const response = await axiosInstance.delete(`${this.endpoint}/documents/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting data:', error);
        throw error;
    }
}

}

const eventService = new EventService();

export { eventService };